var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPixPreto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "40.000000pt",
    height: "40.000000pt",
    viewBox: "0 0 40.000000 40.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,40.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135 359 l-45 -41 48 -44 c26 -24 52 -43 58 -44 5 0 23 14 40 31 16 17 40 35 54 41 l25 9 -47 45 c-26 24 -56 44 -68 44 -11 0 -40 -18 -65 -41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 255 c-17 -20 -31 -44 -31 -55 0 -28 58 -90 84 -90 12 0 39 17 61 40 21 22 45 40 52 40 8 0 33 -18 57 -40 24 -22 52 -40 64 -40 24 0 82 63 82 90 0 28 -58 90 -85 90 -13 0 -41 -18 -65 -40 -23 -22 -48 -40 -54 -40 -7 0 -30 18 -51 40 -48 50 -74 51 -114 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 126 l-48 -44 45 -41 c25 -23 54 -41 65 -41 12 0 42 20 68 44 l47 45 -25 9 c-14 6 -38 24 -54 41 -17 17 -35 31 -40 31 -6 -1 -32 -20 -58 -44z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPixPreto);
export default __webpack_public_path__ + "static/media/logoPixPreto.11d741e9.svg";
export { ForwardRef as ReactComponent };